(function (ebusy, $) {

	/**
	 * Do a post via javascript.
	 */
	ebusy.post = function(path, parameters) {

	    var form = $("<form></form>");

	    form.attr("method", "post");
	    form.attr("action", path);

	    $.each(parameters, function(key, value) {
	        if ( typeof value == "object" ){
	            $.each(value, function(subkey, subvalue) {
	                var field = $("<input />");
	                field.attr("type", "hidden");
	                field.attr("name", key);
	                field.attr("value", subvalue);
	                form.append(field);
	            });
	        } else {
	            var field = $("<input />");
	            field.attr("type", "hidden");
	            field.attr("name", key);
	            field.attr("value", value);
	            form.append(field);
	        }
	    });

		if($("input[name='_csrf']").length && $("input[name='_csrf']").val() != "") {
			form.append($("input[name='_csrf']"));
		} else {
		    form.append(
				$("<input>")
		    	.attr("type", "hidden")
		    	.attr("name", "_csrf")
		    	.val($("meta[name='_csrf']").attr("content"))
			);
		}

	    $(document.body).append(form);

	    form.submit();
	};

	/**
	 * Read a file from file input.
	 */
	ebusy.readFile = function(input, callback) {
		if (input && input.files && input.files[0]) {
	    	var reader = new FileReader();
	    	reader.onload = callback;
			reader.readAsDataURL(input.files[0]);
		}
	};
	
	ebusy.copyToClipboard = function(toCopy) {
	  $(toCopy)[0].select();
	  document.execCommand('copy');
	};

	/**
	 * Calls a function again and again with exponential time decrease
	 */
	ebusy.easingTimeout = function(delay, min, fn) {
		var id,
		invoker = function() {
			fn();
			delay = Math.max(min, Math.floor(delay / 1.3));
			if (delay) {
				id = setTimeout(invoker, delay);
			} else {
				id = null;
			}
		};

		// start it off
		id = setTimeout(invoker, delay);

		return {
			clear: function() {
				if (id) {
					clearTimeout(id);
					id = null;
				}
			}
		}
	};

	/**
	 * Resolves a nested property on a js object.
	 */
	ebusy.resolveNestedProperty = function(propertyPath, targetObj) {
		return propertyPath.split('.').reduce(function(prev, curr) {
			return prev ? prev[curr] : undefined
		}, targetObj);
	};

	/**
	 * Removes a parameter from an URL.
	 */
	ebusy.removeParam = function(url, paramName) {
		var regexp1 = new RegExp("[&]" + paramName + "=([^&]$|[^&]*)", "i");
		url = url.replace(regexp1, "");

		var regexp2 = new RegExp("[?]" + paramName + "=([^&]$|[^&]*)", "i");
		return url.replace(regexp2, "?").replace("?&", "?");
	};
	
	/**
	 * Add/replaces a parameter in an URL.
	 */
	ebusy.addParam = function(url, paramName, paramValue) {
		var url = new URL(url);
		url.searchParams.set(paramName, paramValue);
		return url;
	};

	/**
	 * retrieves a parameter value from an URL.
	 */
	ebusy.getGetParameter = function(paramName) {
		var result = null;
		var tmp = [];

		location.search
			.substr(1)
			.split("&")
			.forEach(function (item) {
				tmp = item.split("=");
				if (tmp[0] === paramName) {
					result = decodeURIComponent(tmp[1])
				}
			});
		return result;
	};

	ebusy.getParam = function get(name) {
		if(name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(window.location.search)) {
			return decodeURIComponent(name[1]);
		}
	};

	ebusy.hexToRgba = function(hex, opacity) {
		return "rgba(" + parseInt(hex.slice(-6, -4), 16) + "," + parseInt(hex.slice(-4, -2), 16) + "," + parseInt(hex.slice(-2), 16) + "," + opacity + ")";
	};

	ebusy.lockButton = function(button) {
		$("<div class='overlay submit-in-progress' />").appendTo($(button).parent());
		$(button).addClass("disabled");
		$(button).addClass("submit-in-progress");
	};

	ebusy.lockButtonOnClick = function(button) {
		button.on("click", function() {
			ebusy.lockButton(button);
		});
	}

	ebusy.unlockButton = function(button) {
		$(button).parent().find(".overlay").remove();
		$(button).removeClass("disabled");
		$(button).removeClass("submit-in-progress");
	};
	
	ebusy.isButtonLocked = function(button) {
		$(button).hasClass("disabled") && $(button).hasClass("submit-in-progress");
	};

	ebusy.isTouchDevice = function() {
		return (('ontouchstart' in window) ||
			(navigator.maxTouchPoints > 0) ||
			(navigator.msMaxTouchPoints > 0)) ||
			('matchMedia' in window && window.matchMedia("(pointer: coarse)").matches);
	}

	var htmlEntities = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		"'": '&#39;',
		'/': '&#x2F;',
		'`': '&#x60;',
		'=': '&#x3D;'
	};

	ebusy.escapeHtml = function escapeHtml (string) {
		return String(string).replace(/[&<>"'`=\/]/g, function (s) {
			return htmlEntities[s];
		});
	}
	
	ebusy.logoutTimer = function(seconds) {
		$(document).idle({
            onIdle: function(){
                $.get("/logout", function(data) {
					window.location.reload();
				});
            },
            idle: seconds * 1000,
            recurIdleCall: false
        });
	}

})(window.ebusy = window.ebusy || {}, window.jQuery);

/**
 * Array.filter polyfill
 */
if (!Array.prototype.filter) {
	Array.prototype.filter = function(func, thisArg) {
    'use strict';
    	if ( ! (typeof func === 'function' && this) )
    		throw new TypeError();

    	var len = this.length >>> 0,
        	res = new Array(len), // preallocate array
        	t = this, c = 0, i = -1;

    	if (thisArg === undefined) {
    		while (++i !== len){
    			// checks to see if the key was set
    			if (i in this){
    				if (func(t[i], i, t)){
    					res[c++] = t[i];
    				}
    			}
    		}
    	}
    	else{
    		while (++i !== len){
    			// checks to see if the key was set
    			if (i in this){
    				if (func.call(thisArg, t[i], i, t)){
    					res[c++] = t[i];
    				}
    			}
    		}
    	}

    	res.length = c; // shrink down array to proper size
    	return res;
	};
}

/**
 * Array.find polyfill
 */
if (!Array.prototype.find) {
	Object.defineProperty(Array.prototype, 'find', {
		value: function(predicate) {

			// 1. Let O be ? ToObject(this value).
			if (this == null) {
				throw new TypeError('"this" is null or not defined');
			}

			var o = Object(this);

			// 2. Let len be ? ToLength(? Get(O, "length")).
			var len = o.length >>> 0;

			// 3. If IsCallable(predicate) is false, throw a TypeError exception.
			if (typeof predicate !== 'function') {
				throw new TypeError('predicate must be a function');
			}

			// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
			var thisArg = arguments[1];

			// 5. Let k be 0.
			var k = 0;

			// 6. Repeat, while k < len
			while (k < len) {
				// a. Let Pk be ! ToString(k).
				// b. Let kValue be ? Get(O, Pk).
				// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
				// d. If testResult is true, return kValue.
				var kValue = o[k];
				if (predicate.call(thisArg, kValue, k, o)) {
					return kValue;
				}
				// e. Increase k by 1.
				k++;
			}

			// 7. Return undefined.
			return undefined;
		},
		configurable: true,
		writable: true
  });
}

$(function(){
	
	var token = $("meta[name='_csrf']").attr("content");
	
	if($("input[name='_csrf']").length && $("input[name='_csrf']").val() != "") {
		token = $("input[name='_csrf']").val();
	}
	
	var header = $("meta[name='_csrf_header']").attr("content");

	$.ajaxSetup({
		beforeSend: function (xhr, settings) {
			xhr.setRequestHeader("X-Ajax-call", "true");
			
			if(header !== undefined) {
				xhr.setRequestHeader(header, token);
			}
	    }
	});

	$(document).ajaxError(function(ev, xhr, options, exception) {
		if (xhr && xhr.status == 401) {
			// in the backend the session ended (e.g. a restart): reloading the page leads to the backend login and back
			// here; the frontend's login modal does not belong there
			if (window.location.pathname === "/backend" || window.location.pathname.indexOf("/backend/") === 0) {
				var page = ebusy.removeParam(window.location.href, "triggerModal");
				window.location.href = page.substr(-1) === "#" ? page.substr(0, page.length - 1) : page;
				return;
			}

			// the login dialog on this page, which keeps its own parameters (the grid's date); a dialog that asked for the
			// login opens again after it
			var page = ebusy.removeParam(ebusy.removeParam(window.location.href, "triggerModal"), "afterLogin");
			var target = ebusy.addParam(page, "triggerModal", "/login");
			// as a path of this site: the dialog may have been asked for relative to this page or with the host
			var modal = options && options.opensModal ? new URL(options.url, window.location.href) : null;
			if (modal && modal.origin === window.location.origin) {
				target.searchParams.set("afterLogin", modal.pathname + modal.search);
			}
			window.location.href = target.toString();
			return;
		}

		if (xhr && xhr.status == 403) {
			var href = ebusy.removeParam(window.location.href, "triggerModal");

		    if(href.substr(-1) === '#') {
		    	href = href.substr(0, href.length - 1);
		    }
			
			if(window.location.href.includes("/backend")) {
				window.location.href = "/";
				return;
			}
			
			window.location.href = href;
			return;
		}
	});

	/**
	 * prevent double submission in flows and forms
	 */
	$(document).on("click", ".modal-dialog button.btn[data-target]:not(.allow-multiple-submits), " +
		".modal-footer button.btn:not(.allow-multiple-submits), button.btn[name='button_save']:not(.allow-multiple-submits), " +
		"button.btn[name='button_send']:not(.allow-multiple-submits)", function() {
		ebusy.lockButton($(this));
	});

	/**
	* Undo changes made to the document to prevent double submission and retained in
	* the browser's bfcache when user returns to the form page via the back button.
	*/
	$(window).on("pageshow", function() {
		$(".submit-in-progress.overlay").remove();
		$(".submit-in-progress")
		.removeClass("submit-in-progress")
		.removeClass("disabled");
	});

	/**
	 * shows passwords
	 */
	$(document).on("click", ".show-password", function() {
		$checkbox = $(this);
		$(this).closest("form").find(".showable-password").each(function() {
			if ($checkbox.is(":checked")) {
				$(this).attr("type", "text");
			} else {
				$(this).attr("type", "password");
			}
		});
	});
	
	/**
	 * asks for the town while the IBAN belongs to a bank outside the EEA: a debit from there must carry it
	 */
	function toggleSepaDebtorAddress($iban) {
		var $address = $iban.closest("form").find(".sepa-debtor-address");
		if (!$address.length) {
			return;
		}
		var eea = String($address.data("eea")).split(",");
		var country = String($iban.val() || "").replace(/\s/g, "").substring(0, 2).toUpperCase();
		var outsideEea = /^[A-Z]{2}$/.test(country) && eea.indexOf(country) === -1;
		$address.toggleClass("d-none", !outsideEea && !$address.hasClass("sepa-town-rejected"));
	}

	$(document).on("input change", ".sepa-iban", function() {
		toggleSepaDebtorAddress($(this));
	});

	/**
	 * a flow step re-rendered in the modal arrives with the town block hidden again
	 */
	function initSepaDebtorAddresses() {
		$(".sepa-iban").each(function() {
			toggleSepaDebtorAddress($(this));
		});
	}

	$(document).on("form.init", initSepaDebtorAddresses);

	initSepaDebtorAddresses();

	if (window.location !== window.parent.location ) {
        $(".iframe-alert").removeClass("d-none");
    } 
});
